import { Component, inject, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import {
  Validators,
  ValidatorFn,
  ValidationErrors,
  FormBuilder,
  FormGroup,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatLabel, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { TitleCasePipe } from '@angular/common';
import { L10nTranslatePipe } from 'angular-l10n';
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'\u0027*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-copy-user',
  templateUrl: './copy-user.component.html',
  styleUrl: './copy-user.component.scss',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatLabel,
    MatFormField,
    MatInput,
    MatCheckbox,
    TitleCasePipe,
    L10nTranslatePipe,
  ],
})
export class CopyUserComponent implements OnInit, OnDestroy {
  public userFormGroup: FormGroup<{
    email: FormControl<string | null>;
    rolePermissions: FormControl<boolean | null>;
    profileSettings: FormControl<boolean | null>;
  }>;
  public dialogRef = inject(MatDialogRef<CopyUserComponent>);
  private readonly dialog = inject(MatDialog);
  public data = inject(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  constructor() {
    this.userFormGroup = this.formBuilder.group({
      email: new FormControl('', {
        validators: [Validators.required, Validators.pattern(EMAIL_REGEX)],
      }),
      rolePermissions: new FormControl<boolean | null>(null),
      profileSettings: new FormControl<boolean | null>(null),
    });
    this.userFormGroup.setValidators(this.checkPermissions());
  }
  ngOnInit() {
    /* required for static lable translation */
  }
  checkPermissions(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      return group.controls.rolePermissions.value || group.controls.profileSettings.value
        ? null
        : { notEquivalent: true };
    };
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  copyUser() {
    this.dialogRef.close(this.userFormGroup.value);
  }
  ngOnDestroy() {
    /** label translation purpose added */
  }
}
